const INTEGER_DISPLAY_FIELDS = new Set(['planInvBOM', 'actualInvBOM', 'markdownPlan', 'markdownActual'])

export const getPlannerDisplayDecimals = (field, fallbackDecimals = 0) => {
  if (INTEGER_DISPLAY_FIELDS.has(field)) return 0
  return Math.min(1, Math.max(0, Number(fallbackDecimals) || 0))
}

const formatCanonicalRaw = (value, decimals) => {
  if (!Number.isFinite(Number(value))) return ''
  if (Number(decimals) <= 0) return String(Math.round(Number(value)))
  return Number(value)
    .toFixed(Number(decimals))
    .replace(/\.0+$/, '')
    .replace(/(\.\d*[1-9])0+$/, '$1')
}

export const clampPlannerEditValue = (field, rawNum, fallbackDecimals = 0) => {
  const n = Number(rawNum)
  if (!Number.isFinite(n)) return 0
  const precision = getPlannerDisplayDecimals(field, fallbackDecimals)
  const factor = Math.pow(10, precision)
  return Math.round(n * factor) / factor
}

export const normalizePlannerRawInput = (raw) => String(raw ?? '').replace(/,/g, '').trim()

export const getPlannerEditableRawValue = (field, value, fallbackDecimals = 0) => {
  if (value === null || typeof value === 'undefined' || value === '') return ''
  const n = Number(value)
  if (!Number.isFinite(n)) return ''
  const precision = getPlannerDisplayDecimals(field, fallbackDecimals)
  return formatCanonicalRaw(clampPlannerEditValue(field, n, fallbackDecimals), precision)
}

export function formatPlannerEditableDisplayValue(field, value, decimals = 0) {
  if (value === null || typeof value === 'undefined' || value === '') return ''
  const n = Number(value)
  if (!Number.isFinite(n)) return ''
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: getPlannerDisplayDecimals(field, decimals),
  })
}

export const parsePlannerEditedValue = (field, rawValue, fallbackDecimals = 0) => {
  const raw = normalizePlannerRawInput(rawValue)
  if (raw === '' || raw === '.') return 0
  const nextNum = Number(raw)
  if (!Number.isFinite(nextNum)) return null
  return clampPlannerEditValue(field, nextNum, fallbackDecimals)
}

export const hasPlannerValueChanged = (field, rawValue, originalValue, fallbackDecimals = 0) => {
  const parsed = parsePlannerEditedValue(field, rawValue, fallbackDecimals)
  if (parsed === null) return false
  const original = clampPlannerEditValue(field, originalValue, fallbackDecimals)
  const safeOriginal = Number.isFinite(original) ? original : 0
  return Math.abs(parsed - safeOriginal) > 0.0000001
}

